import * as ActionType from '../../constants/actionType';

export const undoItem = (keyName) => (dispatch, getState) => {
  dispatch({
    type: ActionType.UNDO_REDO_STATE_UNDO_ITEM,
    keyName,
  });

  const {undoRedoState} = getState();
  const {present} = undoRedoState[keyName];

  return present;
};

export const redoItem = (keyName) => (dispatch, getState) => {
  dispatch({
    type: ActionType.UNDO_REDO_STATE_REDO_ITEM,
    keyName,
  });

  const {undoRedoState} = getState();
  const {present} = undoRedoState[keyName];

  return present;
};

export const newItem = (keyName, data, oldData) => ({
  type: ActionType.UNDO_REDO_STATE_NEW_ITEM,
  keyName,
  data,
  oldData,
});

export const restoreItem = (keyName, past) => ({
  type: ActionType.UNDO_REDO_STATE_RESTORE_ITEM,
  keyName,
  past,
});

export const updatePresentItem = (keyName, data) => ({
  type: ActionType.UNDO_REDO_UPDATE_PRESENT_ITEM,
  keyName,
  data,
});

export const clearItem = (keyName) => ({
  type: ActionType.UNDO_REDO_STATE_CLEAR_ITEM,
  keyName,
});

export const restoreAll = (state) => ({
  type: ActionType.UNDO_REDO_STATE_RESTORE_ALL,
  state,
});

export const resetUndoRedoState = () => ({
  type: ActionType.UNDO_REDO_STATE_RESET,
});
